export default {
  "HOME": "Home"
};
